export enum QUERY_KEYS {
	GET_PLANS = 'get-plans',
	GET_PLAN = 'get-plan',
	GET_FILE = 'get-file',
	GET_USERS = 'get-users',
	GET_METHOD = 'get-method',
	GET_SECTORS = 'get-sectors',
	GET_CELLULES = 'get-cellules',
	GET_COMPANIES = 'get-companies',
	GET_EVIDENCES = 'get-evidences',
	GET_FILES_LIST = 'get-file-list',
	GET_ACTIVITIES = 'get-activities',
	GET_ATTACHMENTS = 'get-attachments',
	GET_ACTION_PLAN = 'get-action-plan',
	GET_RISK_RANGES = 'get-risk-ranges',
	GET_REBA_REPORT = 'get-reba-report',
	GET_ANSIZ_REPORT = 'get-ansiz-report',
	GET_ANSIZ_SCORE = 'get-ansiz-score',
	GET_RULA_REPORT = 'get-rula-report',
	GET_ANSIZ_IMAGE = 'get-ansiz-image',
	GET_NIOSH_REPORT = 'get-niosh-report',
	GET_COMPANY_USERS = 'get-company-users',
	GET_PERMISSIONS = 'get-all-permissions',
	GET_KIM_PP_REPORT = 'get-kim-pp-report',
	GET_THUMBNAIL_URL = 'get_thumbnail_url',
	GET_KIM_MHO_REPORT = 'get-kim-mho-report',
	UPDATE_ANSIZ_IMAGE = 'update-ansiz-image',
	DELETE_ANSIZ_IMAGE = 'delete-ansiz-image',
	GET_FILE_HIERARCHY = 'get-gile-hierarchy',
	GET_METHOD_LIST_OPTIONS = 'get-method-list-options',
	GET_RELATED_REPORTS = 'get-related-reports',
	GET_CELLULE_OPTIONS = 'get-cellule-options',
	GET_MULTIPLE_CELLULE_OPTIONS = 'get-multiple-cellule-options',
	GET_ACTIVITY_OPTIONS = 'get-activity-options',
	GET_USER_PERMISSIONS = 'get-user-permissions',
	GET_ANSIZ_ACTION_PLAN = 'get-ansiz-action-plan',
	GET_ANSIZ_FACTOR_SCORE = 'get-ansiz-factor-score',
	GET_ANSIZ_REPORT_STEPS = 'get-ansiz-report-steps',
	GET_ANSIZ_REPORT_STEP_VALUES = 'get-ansiz-report-step-values',
	CREATE_ANSIZ_URL_SIGNED = 'create-ansiz-url-signed',
	GET_STRAIN_INDEX_REPORT = 'get-strain-index-report',
	GET_ANSIZ_REPORT_ANGLES = 'get-ansiz-report-angles',
	GET_ACTION_PLAN_LIST = 'get-action-plan-list',
	GET_ACTION_PLAN_TASKS = 'get-action-plan-tasks',
	GET_ACTION_PLANS_COUNT = 'get-action-plans-count',
	GET_ACTION_PLAN_HISTORY = 'get-action-plan-history',
	GET_ACTION_PLAN_ORIGINS = 'get-action-plan-origins',
	GET_ACTION_PLAN_COMMENTS = 'get-action-plan-comments',
	GET_RESPONSIBLES_OPTIONS = 'get-responsibles-options',
	GET_PLANS_CONTRACT_PLANS = 'get-plans-contract-plans',
	GET_WORKSTATIONS_OPTIONS = 'get-workstations-options',
	GET_ACTION_PLAN_CARD_LIST = 'get-action-plan-card-list',
	GET_COMPANY_CONTRACT_PLANS = 'get-company-contract-plans',
	GET_REBA_REPORTS_PAGINATED = 'get-reba-reports-paginated',
	GET_ANSIZ_REPORTS_PAGINATED = 'get-ansiz-reports-paginated',
	GET_ACTION_PLANS_BY_REPORT = 'get-action-plans-by-report',
	GET_ROSA_REPORTS_PAGINATED = 'get-rosa-reports-paginated',
	GET_OWAS_REPORTS_PAGINATED = 'get-owas-reports-paginated',
	GET_RULA_REPORTS_PAGINATED = 'get-rula-reports-paginated',
	GET_NIOSH_REPORTS_PAGINATED = 'get-niosh-reports-paginated',
	GET_ATTACHMENT_DOWNLOAD_URL = 'get-attachment-download-url',
	GET_ACTION_PLAN_FROM_REPORT = 'get-action-plan-from-report',
	GET_COMPANIES_CONTRACT_PLANS = 'get-companies-contract-plans',
	GET_KIM_MHO_REPORTS_PAGINATED = 'get-kim-mho-reports-paginated',
	GET_KIM_PP_REPORTS_PAGINATED = 'get-kim-pp-reports-paginated',
	GET_ACTION_PLAN_NOTIFICATIONS = 'get-action-plan-notifications',
	GET_COMPANIES_WITH_ORGANIZATION = 'get-company-with-organization',
	GET_ANSIZ_REPORT_ANGLES_DOUGHNUT = 'get-ansiz-report-angles-doughnut',
	GET_TASK_ATTACHMENT_DOWNLOAD_URL = 'get-task-attachment-download-url',
	GET_ANGLE_TIME_REPORTS_PAGINATED = 'get-angle-time-reports-paginated',
	GET_ORGANIZATIONS_CONTRACT_PLANS = 'get-organizations-contract-plans',
	GET_CUSTOM_REPORT_RESULT_PAGINATED = 'get-custom-report-result-paginated',
	GET_STRAIN_INDEX_REPORTS_PAGINATED = 'get-strain-index-reports-paginated',
	GET_LIBERTY_MUTUAL_REPORTS_PAGINATED = 'get-liberty-mutual-reports-paginated',
	GET_ORGANIZATION_USERS_CONTRACT_PLANS = 'get-organization-users-contract-plans',
	GET_PRELIMINARY_ANALYZES_RESULT_PAGINATED = 'get-preliminary-analyzes-result-paginated',
	GET_MOSAIC = 'get-mosaic',
	GET_CUSTOM_REPORT_OPTIONS = 'get-custom-report-options',
	GET_STATUS_ACTION_PLANS = 'get-status-action-plans',
	GET_CUSTOM_REPORT_WORST_RISK = 'get-custom-report-worst-risk',
	GET_CUSTOM_REPORT_WORST_SCORES = 'get-custom-report-worst-scores',
	GET_CUSTOM_REPORT_EVOLUTION = 'get-custom-report-evolution',
	GET_CUSTOM_REPORT_RISK_EVOLUTION = 'get-custom-report-risk-evolution',
	GET_CUSTOM_REPORT_COUNT_HIGHER_RISK_FOUND = 'get-custom-report-count-higher-risk-found',
	GET_REBA_COUNT_HIGHER_RISK_FOUND = 'get-reba-count-higher-risk-found',
	GET_REBA_BODY_SIDE_EXPOSURE = 'get-reba-body-side-exposure',
	GET_REBA_BODY_PARTS_EXPOSURE = 'get-reba-body-parts-exposure',
	GET_KIM_PP_COUNT_HIGHER_RISK_FOUND = 'get-kim-pp-count-higher-risk-found',
	GET_NIOSH_COUNT_HIGHER_RISK_FOUND = 'get-niosh-count-higher-risk-found',
	GET_RULA_COUNT_HIGHER_RISK_FOUND = 'get-rula-count-higher-risk-found',
	GET_KIM_MHO_COUNT_HIGHER_RISK_FOUND = 'get-kim-mho-count-higher-risk-found',
	GET_WORKSTATIONS_COUNT = 'get-workstation-count',
	GET_STRAIN_INDEX_RISK = 'get-strain-index-risk',
	GET_LIBERTY_MUTUAL_MOVEMENT_INCIDENCE = 'get-liberty-mutual-movement-incidence',
	GET_ACTION_PLAN_USER_PREFERENCE_COLUMNS = 'get-action-plan-user-preference-columns',
	CREATE_PSYCHOSOCIAL_EMPLOYEE = 'create-psychosocial-employee',
	GET_PSYCHOSOCIAL_TOOLS = 'get-psychosocial-tools',
	GET_COMPLETED_SURVEYS = 'get-completed-surveys',
	GET_ORGANIZATION_OPTIONS = 'get-organization-options',
	GET_COMPANY_OPTIONS = 'get-company-options',
	GET_EVALUATOR_OPTIONS = 'get-evaluator-options',
	GET_ERGONOMIC_WORK_ANALYSIS = 'get-ergonomic-work-analysis',
	GET_ERGONOMIC_WORK_ANALYSIS_LIST = 'get-ergonomic-work-analysis-list',
	GET_ERGONOMIC_WORK_ANALYSIS_REPORT_DOWNLOAD = 'get-ergonomic-work-analysis-report-download',
	GET_CUSTOM_REPORTS_CONSOLIDATED = 'get-custom-reports-consolidated',
	GET_CUSTOM_REPORT_SCORE_SCALE_OPTIONS = 'get-custom-report-score-scale-options',
	GET_ROTATION_REPORT = 'get-rotation-report',
	GET_ROTATION_OBJECTIVES = 'get-rotation-objectives',
	GET_ROTATION_REPORTS = 'get-rotation-reports',
	GET_ROTATION_REPORT_ACTIVITIES = 'get-rotation-report-activities',
	GET_ROTATION_REPORT_CYCLE_TOTAL_TIME = 'get-rotation-report-cycle-total-time',
	GET_ROTATION_REPORT_ACTIVITY_RISK_RANGES = 'get-rotation-report-activity-risk-ranges',
	GET_ROTATION_REPORT_BODY_PART_EXPOSURE = 'get-rotation-report-body-part-exposure',
	GET_ROTATION_REPORT_RESULT = 'get-rotation-report-result',
	GET_ROTATION_REPORT_FILES = 'get-rotation-report-files',
	ROTATION_REPORTS = 'rotation-reports',
	ROTATION_REPORT = 'rotation-report',
	ROTATION_REPORT_ACTIVITIES = 'rotation-report-activities',
	GET_ONGOING_SURVEYS = 'get-ongoing-surveys',
	GET_ONE_SURVEY = 'get-one-survey',
	GET_FILES_FROM_CONSOLIDATED_CUSTOM_REPORT = 'get-files-from-consolidated-custom-report',
	GET_TOOL_RESULT = 'get-tool-result',
	GET_PSYCHOSOCIAL_EVALUATIONS = 'get-psychosocial-evaluations',
	GET_AEP_PSYCHOSOCIAL = 'get-aep-psychosocial',
	GET_ACTION_PLANS = 'get-action-plans',
	GET_PSYCHOSOCIAL_PARTICIPATION_ANSWERS = 'get-psychosocial-participation-answers',
	GET_SELECTED_CUSTOM_REPORT_RESULTS = 'get-selected-custom-report-results',
	GET_CUSTOM_REPORT_STEPS_BY_RESULT = 'get-custom-report-steps-by-result',
	GET_CUSTOM_REPORT_STEP_KEYS_BY_RESULT = 'get-custom-report-step-keys-by-result',
	GET_EWA_SELECTED_STEP_KEY_RESULTS = 'get-ewa-selected-step-key-results',
	GET_STEPS_WITH_MAXIMUM_RESULT = 'get-steps-with-maximum-results',
	GET_EWA_SIGNATURE = 'get-ewa-signature',
	LIST_EWA_SIGNATURES = 'list-ewa-signatures',
	GET_EWA_SIGNATURE_RESPONSIBLE = 'get-ewa-signature-responsible',
	LIST_EWA_SIGNATURE_RESPONSIBLES = 'list-ewa-signature-responsibles',
	GET_CUSTOM_REPORT_RESULT_ACTION_LOGS = 'get-custom-report-result-action-logs',
	GET_CUSTOM_REPORT_RESULT_ACTION_PLANS = 'get-custom-report-result-action-plans',
	GET_CUSTOM_REPORT_ERGONOMIC_TOOLS = 'get-custom-report-ergonomic-tools',
	GET_PSYCHOSOCIAL_EMPLOYEES = 'get-psychosocial-employees',
	GET_PSYCHOSOCIAL_EMPLOYEE = 'get-psychosocial-employee',
	DELETE_PSYCHOSOCIAL_EMPLOYEE = 'delete-psychosocial-employee',
	GET_PARTICIPATIONS_BY_EMPLOYEE = 'get-psychosocial-participations-by-employee',
	GET_PSYCHOSOCIAL_RESULTS_PDF = 'get-psychosocial-results-pdf',
	GET_SURVEYS_BY_TIME = 'get-surveys-by-time',
	GET_COMPLETED_SURVEYS_GENERAL = 'get-completed-surveys-general',
	GET_GENERAL_RESULTS_BY_CATEGORY = 'get-general-results-by-category',
	GET_SUPER_PRELIMINARY_ANALYSIS_LIST = 'get-super-preliminary-analysis-list',
	DELETE_SUPER_PRELIMINARY_ANALYSIS = 'delete-super-preliminary-analysis',
	GET_SUPER_PRELIMINARY_ANALYSIS_DOWNLOAD = 'get-super-preliminary-analysis-download',
	GET_REBA_SCORES = 'get-reba-scores',
	GET_REBA_RISK_RANGE = 'get-reba-risk-range',
	GET_REBA_SCORE_PARTS = 'get-reba-score-parts',
	GET_REBA_WORST_GRADE = 'get-reba-worst-grade',
	GET_REBA_SCORE_PER_SECOND = 'get-reba-score-per-second',
	GET_RULA_SCORE_PARTS = 'get-rula-score-parts',
	GET_RULA_WORST_GRADE = 'get-rula-worst-grade',
	GET_ROSA_RESULT = 'get-rosa-result',
	GET_OWAS_RESULT = 'get-owas-result',
	GET_LIBERTY_MUTUAL_RESULT = 'get-liberty-mutual-result',
	GET_RISK_MATRIX_CONSEQUENCES = 'get-risk-matrix-consequences',
	GET_RISK_MATRIX_EXPOSURES = 'get-risk-matrix-exposures',
	GET_RISK_MATRIX_PROBABILITIES = 'get-risk-matrix-probabilities',
	GET_RISK_MATRIX_BY_SURVEY = 'get-risk-matrix-by-survey',
	GET_ACTION_PLAN_BY_RISK_MATRIX = 'get-action-plan-by-risk-matrix',
	CREATE_RISK_MATRIX_ACTION_PLAN = 'create-risk-matrix-action-plan',
	GET_RISK_MATRIX_ATTACHMENTS = 'get-risk-matrix-attachments',
	GET_RISK_MATRIX_ACTION_PLAN_ATTACHMENTS = 'get-risk-matrix-action-plan-attachments',
	GET_RETURN_OF_INVESTMENTS = 'get-return-of-investments',
	GET_ERGONOMIC_WORK_ANALYSIS_IMAGES = 'get-ergonomic-work-analysis-images',
	GET_PSYCHOSOCIAL_EMPLOYEE_EDUCATION_LIST = 'get-psychosocial-employee-education-list',
	GET_PSYCHOSOCIAL_EMPLOYEE_WORK_SHIFT_LIST = 'get-psychosocial-employee-work-shift-list',
	CREATE_PSYCHOSOCIAL_EMPLOYEE_WORK_SHIFT = 'create-psychosocial-employee-work-shift',
}
